import React from 'react';
import { modalMessages, ids } from 'apps/web_forms/utils/constants';
import Modal from 'apps/web_forms/components/commons/Modal';

export const MultiDispatchFailureModal = ({ extraProps }) => {
  
  const { 
    setMultiDispatchFailModalOpen = () => { }, 
    onClick = () => { } 
  } = extraProps || {};

  return (
    <Modal
      mainMessage={modalMessages.multiDispatchFail.main}
      helpTip={modalMessages.multiDispatchFail.tip}
      isOpen={true}
      setIsOpen={setMultiDispatchFailModalOpen}
      icon='error'
      testId={ids.FormIds.MultiDispatchFailModal}
      buttons={[
        {
          id: ids.FormIds.MultiDispatchFailModalOkButton,
          label: 'Ok',
          onClick: onClick,
          filled: true,
        },
      ]}
    />
  );
};
